module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABC0lEQVQ4ja2UsUrDUBSGv8QMbd/BtQ9gt+Jol5LBBBzcfAQF+xoOPoc0i5YqbkrdsnUpDupS8AFMl6JcOCdcQm+oN/nhkpwD5yP3/v8NbSswvN/XeAokDdlZcHyfhlI0hZWM0GosgU95n/lSbeAT8AZsgFvgxwcYyTMHrqz+3IOV28Ah0AcOfL4K2AIrG3gihxrVz9UCTVIeFHAHdDxhqnOgp6Y0hRl1qbg8kaCfSp1Iraur51Qn3XIBXAMxcCi9G+DSmo3EOJcKLOAZkIrLH8CLY+jd0VdTSuAz8NVmbBbAkSdMZYI9UFOawkrGf4P86LiWY2DkA1yLaVV9a0OB2Z7/xAtZu2QYLQv4A7SgLSJBT3sgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/alarmList/warning_equipment.png
// module id = AFgx
// module chunks = 1